import React from 'react'
import { Link } from 'react-router-dom'

import { ApoloProgressBar } from '../../../../../../Charts/ProgressBar'

import { tutorRegistrationTests } from '../../../../../../../constants'

const Quizz = ({ quizz, mainCategories = [] }) => {
  const progress = quizz.total_questions
    ? (quizz.questions_attempted / quizz.total_questions) * 100
    : 0

  const quizCategory = mainCategories.find(
    (category) => category.slug === quizz.quiz_template_category
  )
  const tutorRegistrationTestFound = tutorRegistrationTests.find(
    (test) => test.slug === quizz.quiz_template_category
  )
  const icon = tutorRegistrationTestFound?.icon

  return (
    <div className="w-full flex items-center pl-[10px] py-[6px] pr-[6px] mb-[6px] rounded bg-[#FFF5EE]">
      {icon && (
        <div className="flex w-[56px] h-[56px] mr-[8px]">
          <img src={icon} alt={quizCategory?.name} className="w-full h-full" />
        </div>
      )}

      <div className="flex-1">
        <div className="flex items-center justify-between mb-[7px]">
          <span className="font-bold text-sm text-primary-100 w-[60%] text-ellipsis whitespace-nowrap overflow-hidden">
            {quizCategory?.name}
          </span>

          {/* TODO */}
          <Link className="flex items-center roiBorder rounded p-1 bg-white h-[22px]">
            <span className="font-Inter not-italic font-medium text-[10px] text-[#F79009] hover:text-[#F79009]">
              Go to Quiz
            </span>
          </Link>
        </div>

        <p className="font-Inter not-italic font-normal text-xs text-[#F67443]">
          Tutor: <span className="font-semibold">{quizz.tutor}</span>
        </p>

        <p className="font-Inter not-italic font-normal text-[10px] text-[#F67443] mb-[2px]">
          {quizz.questions_attempted} of {quizz.total_questions} Tasks completed
        </p>

        <ApoloProgressBar
          className="!h-[4px] !rounded-[2px]"
          bgColor="bg-white"
          mainColor="bg-warning-500"
          percentage={progress}
        />
      </div>
    </div>
  )
}

export default Quizz
